import { MenuItemList } from './menu.data';

export const logoutMenu:MenuItemList = [{
        title: 'Cerrar sesión',
        id: 'logout',
        url: '/logout',
        icon: 'log-out-outline',
        isMobile: true,
    }];
